import React from 'react';

import { Role } from '../../consts';

interface Props {
    role: Role;
    languageCode: string;
}

export default function Logo({ role, languageCode = 'en' }: Props) {
    const homeUrl = role === 'contest-holder' ? '/work' : '/';

    return (
        <div className="site-header__item site-header__item--branding">
            <a className="site-header__site-logo" href={homeUrl} title={__('99designs by Vista')}>
                <div
                    className={`site-header__site-logo__image site-header__site-logo__image--${languageCode}`}
                    aria-label={__('99designs by Vista')}
                />
            </a>
        </div>
    );
}
